// for a view only component, any button can do any kind of onclick action
// functions are not serializables so we cannot store them in the state
// thus we store them in this registry
type ActionHandler = () => void
const actionHandlers = new Map<string, ActionHandler>()

const ActionHandlerRegistry = {
    add(id: string, handler: ActionHandler): void {
        actionHandlers.set(id, handler)
    },

    remove(id: string): void {
        actionHandlers.delete(id)
    },

    get(id: string): ActionHandler | undefined {
        return actionHandlers.get(id)
    },

    clear(): void {
        actionHandlers.clear()
    },
}

export default ActionHandlerRegistry
